import { IonSelect, IonSelectOption } from "@ionic/react";
import { forwardRef } from "react";
import { type FieldApi } from "@tanstack/react-form";
import { cn } from "@/lib/style/cva.config";

export type CustomFieldSelectProps = {
  label: string;
  description?: string;
  required?: boolean;
  options: Array<{ label: string; value: string }>;
  multiple?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: FieldApi<
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any
  >;
};

export const CustomFieldSelect = forwardRef<
  HTMLIonSelectElement,
  React.ComponentProps<typeof IonSelect> & CustomFieldSelectProps
>(function CustomFieldSelect(
  { label, description, required = false, options, multiple = false, field, ...props },
  ref,
) {
  return (
    <IonSelect
      ref={ref}
      name={field.name}
      value={field.state.value}
      onIonChange={(event) => field.handleChange(event.detail.value)}
      onIonBlur={field.handleBlur}
      disabled={field.state.meta.isValidating || field.form.state.isSubmitting}
      multiple={multiple}
      {...props}
      labelPlacement={props.labelPlacement ?? "stacked"}
      label={label}
      className={cn(
        required && "ion-required",
        field.state.meta.isTouched && "ion-touched",
        !!field.state.meta.errors && field.state.meta.errors.length > 0 && "ion-invalid",
        props.className,
      )}
    >
      {options.map((option) => (
        <IonSelectOption key={option.value} value={option.value}>
          {option.label}
        </IonSelectOption>
      ))}
    </IonSelect>
  );
});
